import { render, staticRenderFns } from "./artistImages.vue?vue&type=template&id=7a32665e&scoped=true&"
import script from "./artistImages.vue?vue&type=script&lang=js&"
export * from "./artistImages.vue?vue&type=script&lang=js&"
import style0 from "./artistImages.vue?vue&type=style&index=0&id=7a32665e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a32665e",
  null
  
)

export default component.exports